import React from "react";
import {
  Zap,
  MapPin,
  Users,
  AlertCircle,
  DollarSign,
  CalendarCheck,
  Home,
  Award,
} from "lucide-react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/contact";

const ITEMS = [
  { icon: Zap, t: "Atendimento rápido pelo WhatsApp" },
  { icon: MapPin, t: "Entrega ágil em toda a região" },
  { icon: Users, t: "Equipe especializada e treinada" },
  { icon: AlertCircle, t: "Atendimento emergencial" },
  { icon: DollarSign, t: "Preço competitivo e transparente" },
  { icon: CalendarCheck, t: "Compromisso total com prazos" },
  { icon: Home, t: "Atendimento residencial e empresarial" },
  { icon: Award, t: "Empresa confiável em Jundiaí" },
];

export const Differentiators = () => {
  return (
    <section
      id="diferenciais"
      data-testid="diff-section"
      className="relative py-16 md:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="inline-block px-3 py-1 bg-[#0f172a] text-[#fff505] text-xs font-extrabold uppercase tracking-[0.2em] mb-3">
              Diferenciais
            </div>
            <h2
              data-testid="diff-title"
              className="font-display text-4xl sm:text-5xl md:text-6xl text-[#0f172a]"
            >
              Por que escolher a{" "}
              <span className="bg-[#fff505] px-2">PJ Caçambas?</span>
            </h2>
            <p className="mt-5 text-[#475569] font-medium text-base md:text-lg leading-relaxed">
              Somos referência em <strong className="text-[#0f172a]">disk entulho em Jundiaí</strong>.
              Oferecemos agilidade real, preços que cabem no orçamento da sua
              obra e atendimento humano — do primeiro contato até a retirada da
              caçamba.
            </p>
            <a
              href={waLink("Olá! Quero conhecer melhor a PJ Caçambas e pedir um orçamento.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="diff-whatsapp-btn"
              className="mt-7 inline-flex items-center gap-3 px-6 py-4 bg-[#25d366] text-white font-extrabold uppercase tracking-wide border-2 border-[#0f172a] shadow-[6px_6px_0_#0f172a] hover:shadow-[10px_10px_0_#0f172a] hover:-translate-x-[3px] hover:-translate-y-[3px] transition-all"
            >
              <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
              Pedir orçamento agora
            </a>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-4 md:gap-5">
              {ITEMS.map(({ icon: Icon, t }, i) => (
                <li
                  key={t}
                  data-testid={`diff-item-${i}`}
                  className="group relative flex items-start gap-4 p-5 border-2 border-[#0f172a] bg-white hover:bg-[#fff505] transition-colors"
                >
                  <span className="font-display text-3xl text-[#027ec3] group-hover:text-[#0f172a] leading-none w-8 flex-shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1">
                    <Icon className="w-5 h-5 text-[#0f172a] mb-2" strokeWidth={2.5} />
                    <p className="font-bold text-[#0f172a] leading-snug text-[15px]">
                      {t}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
